import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateOrganizationFormData } from '../../schemas/organizations/createOrganization.schema';
import { createOrganization as remiCreateOrganization } from '../../api/remiApi';

export const useCreateOrganization = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const createOrganization = async (data: CreateOrganizationFormData) => {
    const newOrg = {
      org_name: data.org_name,
      org_phone: data.org_phone,
      email: data.email,
      sync_link: data.sync_link || '',
      notification_email: data.notification_email,
      client_address: {
        street: data.client_address.street,
        city: data.client_address.city,
        state: data.client_address.state,
        zip: data.client_address.zip,
      },
      timezone: data.timezone,
      activeClient: data.activeClient ?? true,
      active_subscription: data.active_subscription ?? false,
      accepted_terms: data.accepted_terms ?? false,
      is_onboarding_complete: data.is_onboarding_complete ?? false,
      primary_contact: {
        name: data.primary_contact.name,
        title: data.primary_contact.title,
        email: data.primary_contact.email,
        phone: data.primary_contact.phone,
      },
    };

    const response = await remiCreateOrganization(newOrg);
    return response.organization?.organization_id ?? response.id;
  };

  const { mutateAsync: createOrg, isPending } = useMutation({
    mutationFn: createOrganization,
    onSuccess: () => {
      // Invalidate both the admin list and the organization switcher
      queryClient.invalidateQueries({ queryKey: ['Organizations'] });
      queryClient.invalidateQueries({ queryKey: ['organizationsList'] });
      onSuccess?.();
    },
  });

  return {
    createOrg,
    isPending,
  };
};
